import { createSelector } from "reselect";
import { fakeRootType } from "../../FakeRoot";
import { AppState, UsePortalDispatch, UsePortalSelector } from "../index";

import { logout } from "../upperLevelReducers";
import { selectCurrentUserData, selectIsLoggedIn } from "./userPermissions";
import { setTheme, setThemePreference } from ".";

export const useLogout = (ROOT: fakeRootType) => {
	const dispatch = UsePortalDispatch();

	return () => {
		dispatch(logout());
		ROOT.loadContent("/Login");
	};
};

/**
 * Hook that selects the user from the app state.
 * @returns The user object from the app state.
 */
export const useUser = () => UsePortalSelector(selectCurrentUserData);

/**
 * Selects the user's logged in status from the app state.
 * @returns The user's logged in status from the app state.
 */
export const useIsLoggedIn = () => UsePortalSelector(selectIsLoggedIn);

const selectUserThemeUnsafe = (state: AppState) => state.user.theme ?? "light";

const selectUserTheme = createSelector(selectUserThemeUnsafe, (theme) => theme);

export const useUserTheme = () => UsePortalSelector(selectUserTheme);

export const useSetUserTheme = () => {
	const dispatch = UsePortalDispatch();
	
	return (theme: "light" | "dark") => {
		dispatch(setTheme(theme));
		dispatch(setThemePreference(theme));
	};
};